module.exports = __webpack_public_path__ + "img/1.c5070334.jpeg";